<template>
    <div class="app">
        <scroll @refresh="refresh">
            <section>
                <dl class="field">
                    <dt>体检时间</dt>
                    <dd>{{physicalDetail.examDate | formatDate}}</dd>
                </dl>
                <dl class="field">
                    <dt>健康评价</dt>
                    <dd>{{physicalDetail.evaluation | formatCharacterInfo}}</dd>
                </dl>
                <dl class="field">
                    <dt>健康指导</dt>
                    <dd>
                        {{physicalDetail.guidance | formatCharacterInfo}}
                    </dd>
                </dl>
                <dl class="field last">
                    <dt>危险因素控制</dt>
                    <dd>
                        {{physicalDetail.riskControl | formatCharacterInfo}}
                    </dd>
                </dl>
            </section>
        </scroll>
    </div>
</template>
<script>
export default {
    data() {
        return {
            physicalDetail: {
//                "examDate": "2016-01-01",
//                "evaluation": "体检无异常",
//                "guidance": "多运动",
//                "riskControl": ""
            }
        }
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.physicalDetail = this.$store.state.paramModule.param.healthRecord.physicalItem;
        },
    }
}
</script>


// WEBPACK FOOTER //
// PhysicalExamDetail.vue?bb7d85c0